import {IonPage} from '@ionic/react';
import {documentOutline, documentTextOutline} from 'ionicons/icons';
import {Swiper, SwiperSlide} from 'swiper/react';
import {useRecoilValue} from 'recoil';
import {news} from '../state/news';
import useFetchNews from '../hooks/useFetchNews';
import NewsType from '../types/NewsType';
import UIHeading from '../components/UICommon/UIHeading';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';
import UILoadingIndicator from '../components/UICommon/UILoadingIndicator';
import UINoDataIndicator from '../components/UICommon/UINoDataIndicator';
import UIBackButton from '../components/UICommon/UIBackButton';
import HomePageCard from '../components/HomePage/HomePageCard';
import 'swiper/css';

const HomePage: React.FC = () => {
  const desc = 'Följ stegen i färgdeklarationen och visa sedan din kund hälsodeklarationen med tillhörande färger.';

  const {isLoading, isError} = useFetchNews();
  const newsData: any = useRecoilValue(news);

  return (
    <IonPage className='bg-white px-6 overflow-scroll'>
      <div className='flex flex-col h-full md:pr-12'>
        <div className='flex relative w-full'>
          <UIHeading style='pb-5 w-full' big={true} date={true} title="Vad vill du göra?"
            description='Se dina tidigare deklarationer eller skapa nya här'/>
          <UIBackButton style='absolute top-6 z-40 md:hidden'/>
        </div>
        <div className='flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-6
         md:pb-6 md:border-b-1 border-gray-300 w-full md:max-h-[230px]'>
          <div className='md:w-[60%]'>
            <HomePageCard
              type="gradient"
              title="Deklaration"
              description={desc}
              textSize={'big'}
              icon={documentOutline}
              href="fargdeklaration"/>
          </div>
          <div className='md:w-[40%]'>
            <HomePageCard
              type="gradient"
              title="Skapa egna frågor"
              description='Skapa dina egna deklarationsfrågor. Frågorna syns sist i hälsodeklarationen.'
              textSize={'big'}
              icon={documentTextOutline}
              href="egen-deklaration"/>
          </div>
        </div>
        <div>
          <UIHeading style='border-b-1 pb-4 md:pb-0 md:pt-4 border-gray-500 md:border-none' title='Nyheter'
            description='Här hittar du nyheter och information från oss på SRT'/>
          { isLoading ? <UILoadingIndicator/> : isError ? <UIErrorIndicator/> :
              !newsData || newsData.length == 0 ? <UINoDataIndicator message='Inga nyheter.'/> : (
          <>
            <Swiper spaceBetween={40} className='h-full m-5 md:hidden'>
              {newsData.map((el: NewsType) => (
                <SwiperSlide key={el.id}>
                  <HomePageCard
                    type='image-text'
                    icon='FiFilePlus'
                    href={'home/' + el.id}
                    title={el.title}
                    date={el.created_at}
                    description={el.content}
                    img={el.image}/>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className='hidden md:flex pt-5 space-x-10'>
              {newsData.map((el: NewsType) => (
                <HomePageCard
                  key={el.id}
                  type='image-text'
                  title={el.title}
                  description={el.content}
                  img={el.image}
                  href={'home/' + el.id}
                  style='md:w-1/3'
                />
              ))}
            </div>
          </>
          )}
        </div>
      </div>
    </IonPage>
  );
};

export default HomePage;
